var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"banner"},[_c('div',[_c('img',{attrs:{"src":require("../assets/fisioadapt.png"),"alt":"","width":"60px","height":"60px"}}),_c('h1',[_c('font',{staticStyle:{"color":"rgb(44, 62, 80)"}},[_vm._v("Fisio")]),_vm._v("adapt")],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }